import React, { useState } from "react";
import { Loader2, Wand2, MessageSquareText } from "lucide-react";

const EXAMPLES = [
  "Herringbone oak floor with dark grout",
  "White metro on the back wall, full height",
  "Make it an L-shaped room 3.4m by 2.8m",
  "Swap the bath for a walk-in shower in the left corner",
];

export const CommandBar = ({ onRun, busy, log }) => {
  const [text, setText] = useState("");
  const run = (t) => { if (t.trim() && !busy) { onRun(t.trim()); setText(""); } };
  return (
    <div className="mb-4" data-testid="cad-command-bar">
      <form onSubmit={(e) => { e.preventDefault(); run(text); }} className="flex gap-2 items-center rounded-full border border-rossi-gold/30 bg-rossi-surface/80 backdrop-blur pl-4 pr-1.5 py-1.5 focus-within:border-rossi-gold/70 transition-colors">
        <Wand2 size={17} className="text-rossi-gold shrink-0" />
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Tell The Studio what to change…" className="flex-1 bg-transparent text-sm text-rossi-cream placeholder:text-rossi-stone focus:outline-none min-w-0" data-testid="cad-command-input" />
        <button type="submit" disabled={busy || !text.trim()} className="btn-gold !py-2 !px-4 text-sm disabled:opacity-40" data-testid="cad-command-submit">{busy ? <Loader2 size={15} className="animate-spin" /> : "Apply"}</button>
      </form>
      <div className="flex flex-wrap gap-1.5 mt-2.5">
        {EXAMPLES.map((ex) => <button key={ex} onClick={() => run(ex)} disabled={busy} className="text-[11px] px-2.5 py-1 rounded-full border border-white/10 text-rossi-cream/65 hover:border-rossi-gold/40 hover:text-rossi-cream transition-colors disabled:opacity-40" data-testid="cad-example">{ex}</button>)}
      </div>
      {log.length > 0 && (
        <div className="mt-3 flex gap-2 items-start text-xs text-rossi-cream/80" data-testid="cad-command-reply">
          <MessageSquareText size={14} className="text-rossi-gold mt-0.5 shrink-0" />
          <p><span className="text-rossi-stone">“{log[log.length - 1].q}”</span> — {log[log.length - 1].reply}</p>
        </div>
      )}
    </div>
  );
};

export default CommandBar;
